/* Recomendador de talla Nacionalissimo — interfaz de ficha de producto.
   El catálogo de hormas y la regla de Paulo NO están aquí: viven en el servidor privado (CFG.api).
   Este archivo solo captura medidas, pregunta al servidor y pinta la respuesta.
   Las medidas son del CLIENTE (se guardan una vez); el veredicto es del ESTILO (se pide en cada ficha). */
(function () {
  const cfgEl = document.getElementById('nac-talla-config');
  if (!cfgEl) return;
  const CFG = JSON.parse(cfgEl.textContent);
  if (!CFG.api) return;

  const LS = 'nac-medidas-v1', LS_ULT = 'nac-ultima-talla-v1', LS_SES = 'nac-sesion-v1';
  const leer = (k) => { try { return JSON.parse(localStorage.getItem(k) || 'null'); } catch (e) { return null; } };
  const guardar = (k, v) => { try { localStorage.setItem(k, JSON.stringify(v)); } catch (e) {} };
  const sesion = () => { let id = leer(LS_SES); if (!id) { id = Math.random().toString(36).slice(2) + Date.now().toString(36); guardar(LS_SES, id); } return id; };
  const esc = (s) => String(s == null ? '' : s).replace(/[&<>"']/g, (c) => ({ '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c]));
  const cap = (t) => t ? t.toLowerCase().replace(/(^|[\s-])\S/g, (c) => c.toUpperCase()).replace(/(^|\s)(i{1,3}|iv|v)(?=\s|$)/gi, (m) => m.toUpperCase()) : '';
  const norm = (t) => String(t || '').normalize('NFD').replace(/[̀-ͯ]/g, '').toUpperCase().trim();
  const valido = (m) => m && isFinite(m.L) && isFinite(m.M) && isFinite(m.E);
  const raiz = () => (window.Shopify && Shopify.routes && Shopify.routes.root) || '/';

  // Validación de la captura (rangos humanos; no revela nada de las hormas).
  function validar(L, M1, M2, M3, E) {
    const cm = (v) => { v = parseFloat(String(v).replace(',', '.')); if (!isFinite(v) || v <= 0) return null; return v >= 45 ? { v: v / 10, mm: true } : { v }; };
    const out = { errores: {}, avisos: [] };
    const l = cm(L);
    if (!l) out.errores.largo = 'Captura el largo de tu pie.';
    else if (l.v < 20 || l.v > 33) out.errores.largo = `Un pie de ${l.v.toFixed(1)} cm está fuera de lo normal. Revisa que sea en centímetros.`;
    if (l && l.mm) out.avisos.push(`Interpretamos tu largo como ${l.v.toFixed(1)} cm.`);
    const a = cm(M1), b = cm(M2);
    let M = null, pideTercera = false;
    if (!a || !b) out.errores.meta = 'Captura las dos mediciones del metatarsal.';
    else if (Math.abs(a.v - b.v) > 0.3) {
      const c = cm(M3);
      if (!c) { pideTercera = true; out.errores.meta = 'Tus dos mediciones difieren más de 3 mm — casi siempre es la tensión de la cinta. Toma una tercera, apoyada y sin apretar.'; }
      else { const v = [a.v, b.v, c.v].sort((x, y) => x - y); const p = v[1] - v[0] <= v[2] - v[1] ? [v[0], v[1]] : [v[1], v[2]]; M = (p[0] + p[1]) / 2; }
    } else M = (a.v + b.v) / 2;
    if (M !== null) {
      if (M < 19 || M > 30) out.errores.meta = `Un metatarsal de ${M.toFixed(1)} cm está fuera de lo normal. Debe ser la vuelta completa.`;
      else if (l && !out.errores.largo && (M / l.v < 0.85 || M / l.v > 1.10)) out.errores.meta = 'La proporción entre tu metatarsal y tu largo no es normal. Revisa las dos medidas.';
    }
    const e = cm(E);
    if (!e) out.errores.emp = 'Captura el empeine — es necesario para tu talla.';
    else if (M) {
      const re = e.v / M;
      if (re < 0.97) out.errores.emp = 'El empeine casi siempre es MAYOR que el metatarsal. Pasa la cinta por el hueso alto de la agujeta.';
      else if (re > 1.15) out.errores.emp = 'Ese empeine se ve demasiado grande contra tu metatarsal. Vuelve a medir.';
    }
    out.pideTercera = pideTercera;
    out.ok = !Object.keys(out.errores).length;
    if (out.ok) Object.assign(out, { L: l.v * 10, M: M * 10, E: e.v * 10 });
    return out;
  }

  // Servidor privado del recomendador (con memoria por sesión para no repetir consultas).
  const _memo = {};
  function api(cuerpo) {
    const k = JSON.stringify(Object.assign({ sesion: sesion() }, cuerpo)); // la sesión anónima permite al servidor reconocer a la misma persona
    if (!_memo[k]) {
      let guardada = null;
      try { guardada = JSON.parse(sessionStorage.getItem('nac-api:' + k) || 'null'); } catch (e) {}
      _memo[k] = guardada ? Promise.resolve(guardada) : fetch(CFG.api, { method: 'POST', headers: { 'Content-Type': 'application/json' }, body: k })
        .then((r) => (r.ok ? r.json() : Promise.reject(r.status)))
        .then((d) => { try { sessionStorage.setItem('nac-api:' + k, JSON.stringify(d)); } catch (e) {} return d; })
        .catch((e) => { delete _memo[k]; throw e; });
    }
    return _memo[k];
  }
  const medidasApi = (m) => ({ L: Math.round(m.L * 10) / 10, M: Math.round(m.M * 10) / 10, E: Math.round(m.E * 10) / 10 });

  // Medidas: navegador o ficha de cliente (la más reciente gana). Así se mide una vez en la vida.
  function medidasIniciales() {
    const loc = leer(LS), cli = CFG.cliente;
    if (valido(cli) && (!valido(loc) || String(cli.fecha || '') > String(loc.fecha || ''))) { guardar(LS, cli); return cli; }
    return valido(loc) ? loc : null;
  }

  // Las medidas viajan con el pedido (atributo oculto del carrito) y Shopify Flow las copia a la ficha del cliente.
  function sincronizarCarrito(m) {
    if (!valido(m)) return;
    const v = JSON.stringify({ L: m.L, M: Math.round(m.M * 10) / 10, E: m.E, fecha: m.fecha || '' });
    if (CFG.carrito === v) return;
    CFG.carrito = v;
    fetch(raiz() + 'cart/update.js', {
      method: 'POST', headers: { 'Content-Type': 'application/json' }, body: JSON.stringify({ attributes: { _nac_medidas: v } })
    }).catch(() => {});
  }

  const S = {
    medidas: medidasIniciales(), open: false, step: 1, calc: false, calcIdx: 0,
    estilo: '', largo: '', m1: '', m2: '', m3: '', emp: '', tercera: false, errs: {}, res: null,
    correo: '', avisado: false, med: null, autoSel: false,
    resPdp: null, extra: {}, lista: null, cargando: false
  };
  let estPdp = null; // { nombre, corte, g } del modelo de esta ficha (g = huella opaca de cómo calza)

  /* ---------- Ficha: selector de tallas del tema ---------- */
  const picker = () => document.querySelector('.product-info__block-item[data-block-type="variant-picker"] variant-picker[update-url]')
    || Array.from(document.querySelectorAll('variant-picker')).find((p) => !p.closest('.quick-buy-modal, quick-buy-modal'));
  const formId = () => { const p = picker(); return p && p.getAttribute('form'); };
  const inputTalla = (t) => { const p = picker(); return p && p.querySelector(`input[name="option${CFG.opt}"][value="${String(t)}"]`); };

  function seleccionActual() {
    const p = picker(), sel = {};
    if (!p) return sel;
    p.querySelectorAll('input[type=radio]:checked').forEach((i) => { sel[i.name] = i.value; });
    p.querySelectorAll('select[name^="option"]').forEach((s) => { sel[s.name] = s.value; });
    return sel;
  }
  // Agotada = ninguna variante de esa talla disponible con las demás opciones elegidas (p. ej. el color).
  function tallaDisponible(t) {
    const sel = seleccionActual();
    return CFG.variantes.some((v) => v.a && String(v.o[CFG.opt - 1]) === String(t) &&
      v.o.every((val, i) => i === CFG.opt - 1 || !sel['option' + (i + 1)] || sel['option' + (i + 1)] === val));
  }
  const esPdpNombre = (n) => estPdp && norm(n) === norm(estPdp.nombre);
  function conExistencias(r, nombre) {
    if (!r) return r;
    const x = Object.assign({}, r);
    if (esPdpNombre(nombre) && x.ok && !x.agotada && !tallaDisponible(x.talla)) x.agotada = true;
    return x;
  }

  /* ---------- Sugerencias: modelos que sí le quedan, afines en tipo y tono ---------- */
  let _catalogo = null;
  const tipoN = (x) => String(x || '').replace(/&gt;/g, '>').trim();
  function grupoColor(c) {
    const x = norm(c);
    if (/NEGRO|BLACK/.test(x)) return 'negro';
    if (/AZUL|NAVY/.test(x)) return 'azul';
    if (/MARFIL|ARENA|BEIGE|BLANCO|NATURAL|RIZO/.test(x)) return 'claro';
    if (/CAFE|MARRON|MIEL|HONEY|CONAC|NOGAL|LONDON|CHOCOLATE|TABACO|CANELA|VINO|CAJETA|CAOBA/.test(x)) return 'cafe';
    return 'otro';
  }
  function colorActual() {
    const sel = seleccionActual();
    const k = Object.keys(sel).find((n) => n !== 'option' + CFG.opt);
    return k ? sel[k] : '';
  }
  async function sugerencias(estiloBase, m, max) {
    if (!_catalogo) _catalogo = fetch(raiz() + 'collections/all/products.json?limit=250').then((r) => r.json()).then((d) => d.products || []).catch(() => []);
    const prods = (await _catalogo).filter((p) => /^Calzado/.test(tipoN(p.product_type)) && p.handle !== CFG.handle && norm(p.title) !== norm(estiloBase));
    const nombres = [...new Set(prods.map((p) => p.title))];
    if (!nombres.length) return [];
    const d = await api({ accion: 'varios', nombres, m: medidasApi(m) });
    const modelos = (d && d.modelos) || {};
    const corteBase = esPdpNombre(estiloBase) ? estPdp.corte : ((S.lista || []).find((e) => norm(e.nombre) === norm(estiloBase)) || {}).corte;
    const grupo = grupoColor(colorActual()), tipo = tipoN(CFG.tipo);
    const mejores = {};
    prods.forEach((p) => {
      const r = modelos[norm(p.title)];
      if (!r || !r.ok || norm(r.nombre) === norm(estiloBase)) return;
      const iT = p.options.findIndex((o) => /talla|tama|size/i.test(o.name));
      if (iT < 0) return;
      const iC = p.options.findIndex((o, k) => k !== iT && /color/i.test(o.name));
      const vs = p.variants.filter((v) => v.available && Number(v['option' + (iT + 1)]) === Number(r.talla));
      if (!vs.length) return;
      const v = (iC >= 0 && vs.find((x) => grupoColor(x['option' + (iC + 1)]) === grupo)) || vs[0];
      const mismoTono = iC >= 0 && grupoColor(v['option' + (iC + 1)]) === grupo;
      let puntos = (tipoN(p.product_type) === tipo ? 3 : 0) + (mismoTono ? 2 : 0);
      if (corteBase === 'OXFORD' && r.corte === 'DERBY') puntos += 2;
      if (corteBase && corteBase === r.corte) puntos += 1;
      const img = (v.featured_image && v.featured_image.src) || (p.images[0] && p.images[0].src) || '';
      const sug = { nombre: cap(r.nombre), talla: r.talla, plantilla: r.calce === 'plantilla', url: `/products/${p.handle}?variant=${v.id}`, img: img ? img + (img.includes('?') ? '&' : '?') + 'width=400' : '', puntos };
      const k = norm(r.nombre);
      if (!mejores[k] || mejores[k].puntos < puntos) mejores[k] = sug;
    });
    return Object.values(mejores).sort((a, b) => b.puntos - a.puntos).slice(0, max || 3);
  }
  function pintarSugerencias(estiloBase) {
    const caja = ov && ov.querySelector('#nac-sug');
    if (!caja || !valido(S.medidas)) return;
    sugerencias(estiloBase, S.medidas, 3).then((lista) => {
      if (!lista.length || !caja.isConnected) return;
      caja.innerHTML = `<div class="nac-sug__tit">Estos sí te quedan, en tu talla</div><div class="nac-sug__lista">${lista.map((x) => `
        <a class="nac-sug__item" href="${x.url}">${x.img ? `<img src="${x.img}" alt="${esc(x.nombre)}" loading="lazy">` : ''}<span class="nac-sug__nom">${esc(x.nombre)}</span><span class="nac-sug__talla">Tu talla: ${esc(x.talla)}${x.plantilla ? ' · con plantilla extra' : ''}</span></a>`).join('')}</div>`;
    }).catch(() => {});
  }

  const resultadoPdp = () => (estPdp && valido(S.medidas) ? conExistencias(S.resPdp, estPdp.nombre) : null);

  // Cliente con sesión que ya compró y nunca tuvo cambio ni devolución (metafield nac.con_cambio).
  function compraPrevia() {
    if (!CFG.logueado || CFG.conCambio || !CFG.pedidos) return null;
    const items = (CFG.compras || []).filter(Boolean).map((c) => {
      const est = S.extra[norm(c.e || c.t)];
      const talla = String(c.v || '').split('/').map((x) => x.trim()).find((x) => /^\d{2}(\.5)?$/.test(x));
      return est && talla ? { est, talla: Number(talla) } : null;
    }).filter(Boolean);
    const igual = items.find((x) => x.est.g === estPdp.g) || null;
    return { ultima: items[0] || null, igual };
  }

  // Equivalencias de la tabla del tema (MX · USA · EURO); si la ficha no la trae, misma escala: USA = MX − 18, EURO = MX + 15.
  function equiv(t) {
    const fila = [...document.querySelectorAll('.nx-sg-tb tbody tr')].find((tr) => tr.cells[0] && tr.cells[0].textContent.trim() === String(t));
    if (fila) return { usa: fila.cells[1].textContent.trim(), eu: fila.cells[2].textContent.trim() };
    return { usa: String(Number(t) - 18), eu: String(Number(t) + 15) };
  }

  function pintarFicha() {
    const p = picker();
    if (!p || !estPdp) return;
    const r = resultadoPdp(), m = S.medidas, nombre = cap(estPdp.nombre);
    const cp = m ? null : compraPrevia();
    // Sin medidas, pero ya compró sin cambios un modelo que calza igual: esa es su talla.
    const igual = cp && cp.igual && tallaDisponible(cp.igual.talla) ? cp.igual : null;
    // Ya compró sin cambios (otro modelo): se le propone su talla de siempre, si existe en este modelo.
    const ant = cp && !igual && cp.ultima && tallaDisponible(cp.ultima.talla) ? cp.ultima : null;
    const rec = r && r.ok && !r.agotada ? r.talla : igual ? igual.talla : ant ? ant.talla : null;

    // La talla recomendada hace un pulso leve en azul y se queda marcada
    const actual = p.querySelector('.nac-rec');
    const i = rec != null ? inputTalla(rec) : null;
    const l = i && (p.querySelector(`label[for="${i.id}"]`) || i.nextElementSibling);
    if (actual !== l) {
      if (actual) actual.classList.remove('nac-rec');
      if (l) l.classList.add('nac-rec');
    }
    // Una sola vez por ficha: dejar seleccionada la talla recomendada (si el cliente cambia a mano, se respeta).
    if (l && !S.autoSel) {
      S.autoSel = true;
      if (!i.checked) elegirTalla(rec);
    }

    // Una sola tarjeta debajo de las tallas: estado de la talla, botón al recomendador y equivalencias.
    let card = document.getElementById('nac-talla-card');
    if (!card) {
      card = document.createElement('div'); card.id = 'nac-talla-card'; card.className = 'nac-tc';
      card.addEventListener('click', (e) => { if (e.target.closest('.nac-tc__cta')) abrir(); });
    }
    const eq = rec != null ? equiv(rec) : null;
    let ico = '?', titulo, sub, cta = 'Medir mi pie';
    if (rec != null) {
      ico = '✓'; titulo = ant ? `Elige tu talla de siempre: ${esc(rec)}` : `Tu talla en ${esc(nombre)}: ${esc(rec)}`;
      const origen = m ? (r && r.calce === 'plantilla' ? 'Úsala con una plantilla extra.' : 'Calculada con tus medidas.') : igual ? `Es la que ya compraste${norm(igual.est.nombre) === norm(estPdp.nombre) ? ' en este modelo' : ' en el ' + esc(cap(igual.est.nombre))}, sin cambios.` : '';
      sub = ant ? `Tu ${esc(cap(ant.est.nombre))} en ${esc(rec)} no tuvo cambios: esta talla te quedará bien. USA ${esc(eq.usa)} · EURO ${esc(eq.eu)}` : `USA ${esc(eq.usa)} · EURO ${esc(eq.eu)} · ${origen}`; cta = m ? 'Ver detalle' : 'Confirmar con mis medidas';
    } else if (r && r.ok && r.agotada) {
      ico = '!'; titulo = `Tu talla ${esc(r.talla)} está agotada`; sub = 'Déjanos tu correo y te avisamos en cuanto llegue.'; cta = 'Avísame';
    } else if (r && !r.ok) {
      ico = '!'; titulo = r.motivo === 'rango' ? 'Este modelo no viene en tu talla' : 'Este modelo no es para tu pie'; sub = 'Preferimos decírtelo antes de que compres.'; cta = 'Ver por qué';
    } else if (cp) {
      ico = '✓'; titulo = 'Ya compraste con nosotros';
      sub = `No te preocupes: ${cp.ultima ? `tu ${esc(cap(cp.ultima.est.nombre))} en ${esc(cp.ultima.talla)} no tuvo cambios` : 'tu compra no tuvo cambios'}. Si quieres estar seguro, mídete.`;
    } else {
      titulo = 'Asegura tu talla en 2 minutos';
      sub = 'El cambio de talla no tiene costo, pero medirte hoy te ahorra la espera de un cambio.';
    }
    const tabla = document.getElementById('nxsg-nx') ? '<label for="nxsg-nx" class="nac-tc__tabla">Equivalencias MX · USA · EURO</label>' : '';
    const html = `<div class="nac-tc__main"><span class="nac-tc__ico${ico === '!' ? ' nac-tc__ico--aviso' : ''}">${ico}</span><span class="nac-tc__tit">${titulo}</span></div><p class="nac-tc__sub">${sub}</p><div class="nac-tc__pie"><button type="button" class="nac-tc__cta${rec != null ? ' nac-tc__cta--suave' : ''}" id="nac-talla-pill">${cta}${rec != null ? ' ›' : ''}</button>${tabla}</div>`;
    if (card.dataset.h !== html) { card.innerHTML = html; card.dataset.h = html; }
    // Sin medidas ni compra previa: pulso leve que invita a medirse.
    card.classList.toggle('nac-tc--invita', !m && !cp && rec == null && !(r && !r.ok));
    if (card.previousElementSibling !== p) p.insertAdjacentElement('afterend', card);
  }

  // Selecciona la talla y usa el botón de compra del tema (así el carrito lateral se abre como siempre).
  function agregarCarrito(t) {
    S.autoSel = true;
    elegirTalla(t);
    const fid = formId(), sel = seleccionActual();
    const v = CFG.variantes.find((x) => String(x.o[CFG.opt - 1]) === String(t) &&
      x.o.every((val, i) => i === CFG.opt - 1 || !sel['option' + (i + 1)] || sel['option' + (i + 1)] === val));
    const t0 = Date.now();
    (function intentar() {
      const f = fid && document.getElementById(fid);
      const id = f && f.querySelector('input[name="id"]');
      const listo = !v || (id && String(id.value) === String(v.id));
      const btn = f && (f.querySelector('button[type="submit"]') || document.querySelector(`button[type="submit"][form="${fid}"]`));
      if (listo && btn && !btn.disabled) return btn.click();
      if (Date.now() - t0 < 4000) return setTimeout(intentar, 120);
      if (v) fetch(raiz() + 'cart/add.js', { method: 'POST', headers: { 'Content-Type': 'application/json' }, body: JSON.stringify({ items: [{ id: v.id, quantity: 1 }] }) })
        .then(() => { location.href = raiz() + 'cart'; }).catch(() => {});
    })();
  }

  function elegirTalla(t) {
    const i = inputTalla(t);
    if (!i) return;
    const l = picker().querySelector(`label[for="${i.id}"]`);
    if (l) { l.click(); if (document.activeElement && document.activeElement.blur) document.activeElement.blur(); } else { i.checked = true; i.dispatchEvent(new Event('change', { bubbles: true })); }
  }

  /* ---------- Recomendador (overlay) ---------- */
  let ov, fontCargada = false, _ci, _ct, _t0;
  function abrir() {
    if (!fontCargada) {
      fontCargada = true;
      const l = document.createElement('link'); l.rel = 'stylesheet';
      l.href = 'https://fonts.googleapis.com/css2?family=Inter:wght@400;500;600;700&display=swap';
      document.head.appendChild(l);
    }
    S.open = true; S.errs = {}; S.avisado = false;
    if (estPdp) {
      S.estilo = estPdp.nombre;
      if (valido(S.medidas) && S.resPdp) { S.res = resultadoPdp(); S.step = 6; S.calc = false; registrar(S.res, S.medidas, estPdp.nombre); }
      else { S.step = 1; S.res = null; }
    } else { S.step = 0; }
    if (!ov) {
      ov = document.createElement('div'); ov.className = 'nac-ov'; ov.setAttribute('role', 'dialog'); ov.setAttribute('aria-modal', 'true'); ov.setAttribute('aria-label', 'Recomendador de talla');
      ov.addEventListener('click', (e) => { if (e.target === ov) cerrar(); });
      document.body.appendChild(ov);
      document.addEventListener('keydown', (e) => { if (e.key === 'Escape' && S.open) cerrar(); });
    }
    document.documentElement.classList.add('nac-lock');
    ov.hidden = false;
    render();
    const v = document.createElement('link'); v.rel = 'prefetch'; v.href = CFG.media.escaneo; document.head.appendChild(v);
  }
  function cerrar() {
    S.open = false; clearInterval(_ci); clearTimeout(_ct); S.calc = false;
    if (ov) { ov.hidden = true; ov.innerHTML = ''; }
    document.documentElement.classList.remove('nac-lock');
    pintarFicha();
  }

  function emitir(tipo, data) { window.dispatchEvent(new CustomEvent('nac:' + tipo, { detail: data })); }

  function registrar(res, m, nombre) {
    if (!res) return;
    S.med = { sesion: sesion(), largo_mm: m.L, metatarsal_mm: Math.round(m.M * 10) / 10, empeine_mm: m.E, estilo: nombre, talla_recomendada: res.talla ?? null, calce: res.agotada ? 'agotada' : (res.calce || res.motivo) };
    emitir('medicion', S.med);
    if (res.ok) guardar(LS_ULT, { estilo: norm(nombre), nombre, talla: res.talla });
  }

  // Pide al servidor el veredicto de un modelo con estas medidas.
  async function evaluar(nombre, m) {
    if (esPdpNombre(nombre)) {
      const d = await api({ accion: 'ficha', estilo: CFG.estilo, titulo: CFG.titulo, m: medidasApi(m) });
      S.resPdp = d.res;
      return conExistencias(d.res, nombre);
    }
    const d = await api({ accion: 'recomendar', estilo: nombre, m: medidasApi(m) });
    return d.res;
  }
  const errorServidor = () => ({ ok: false, motivo: 'servidor', texto: 'No pudimos calcular tu talla en este momento. Intenta de nuevo en unos minutos.' });

  async function cargarLista() {
    if (S.lista) return S.lista;
    const d = await api({ accion: 'lista' });
    S.lista = d.estilos || [];
    return S.lista;
  }

  function leerInputs() {
    if (!ov) return;
    ov.querySelectorAll('[data-k]').forEach((i) => { S[i.dataset.k] = i.value; });
  }

  async function next() {
    leerInputs();
    const s = S;
    if (s.step === 0) {
      if (!s.estilo) { s.errs = { modelo: 'Elige un modelo para continuar.' }; return render(); }
      if (valido(s.medidas)) {
        try { s.res = await evaluar(s.estilo, s.medidas); } catch (e) { s.res = errorServidor(); }
        registrar(s.res, s.medidas, s.estilo); s.step = 6; s.calc = false; return render();
      }
      s.step = 1; s.errs = {}; return render();
    }
    if (s.step === 1) {
      const v = validar(s.largo, '', '', '', '');
      if (v.errores.largo) { s.errs = { largo: v.errores.largo }; return render(); }
      s.step = 2; s.errs = {}; return render();
    }
    if (s.step === 2) {
      if (!String(s.m1).trim()) { s.errs = { meta: 'Captura la vuelta de abajo.' }; return render(); }
      const v = validar(s.largo, s.m1, s.m1, '', '');
      if (v.errores.meta) { s.errs = { meta: v.errores.meta }; return render(); }
      s.step = 3; s.errs = {}; return render();
    }
    if (s.step === 3) {
      if (!String(s.m2).trim()) { s.errs = { meta: 'Captura la segunda medición.' }; return render(); }
      const v = validar(s.largo, s.m1, s.m2, '', '');
      if (v.pideTercera) { s.step = 4; s.tercera = true; s.errs = {}; return render(); }
      if (v.errores.meta) { s.errs = { meta: v.errores.meta }; return render(); }
      s.step = 5; s.tercera = false; s.m3 = ''; s.errs = {}; return render();
    }
    if (s.step === 4) {
      if (!String(s.m3).trim()) { s.errs = { meta: 'Captura la tercera medición.' }; return render(); }
      const v = validar(s.largo, s.m1, s.m2, s.m3, '');
      if (v.errores.meta) { s.errs = { meta: v.errores.meta }; return render(); }
      s.step = 5; s.errs = {}; return render();
    }
    if (s.step === 5) {
      const v = validar(s.largo, s.m1, s.m2, s.m3, s.emp);
      if (v.errores.emp) { s.errs = { emp: v.errores.emp }; return render(); }
      if (!v.ok) { s.step = v.errores.largo ? 1 : 2; s.errs = {}; return render(); }
      const medidas = { L: v.L, M: v.M, E: v.E, fecha: new Date().toISOString() };
      guardar(LS, medidas); s.medidas = medidas; s.autoSel = false;
      sincronizarCarrito(medidas);
      s.res = null; s.errs = {}; s.avisado = false; s.calc = true; s.calcIdx = 0;
      s.med = { largo_mm: medidas.L, metatarsal_mm: Math.round(medidas.M * 10) / 10, empeine_mm: medidas.E };
      empezarCalc();
      render();
      // Si se midió desde otro modelo, la tarjeta de esta ficha también se actualiza con las medidas nuevas.
      if (estPdp && !esPdpNombre(s.estilo)) evaluar(estPdp.nombre, medidas).catch(() => {});
      // La animación corre mientras el servidor responde.
      evaluar(s.estilo, medidas).catch(() => errorServidor()).then((res) => {
        if (!res) res = errorServidor();
        res.avisos = v.avisos; s.res = res;
        registrar(res, medidas, s.estilo);
        finCalc();
      });
    }
  }

  function empezarCalc() {
    clearInterval(_ci); clearTimeout(_ct);
    const total = CFG.duracion * 1000;
    _ci = setInterval(() => { S.calcIdx = Math.min(S.calcIdx + 1, 4); pintarCalc(); }, total / 5);
    _ct = setTimeout(finCalc, total + 1500);
    _t0 = Date.now();
  }
  function finCalc() {
    const falta = CFG.duracion * 1000 - (Date.now() - (_t0 || 0));
    if (falta > 50) { clearTimeout(_ct); _ct = setTimeout(finCalc, falta); return; }
    if (!S.res) { clearTimeout(_ct); _ct = setTimeout(finCalc, 300); return; } // espera la respuesta del servidor
    clearInterval(_ci); clearTimeout(_ct);
    if (S.calc) { S.calc = false; S.step = 6; render(); }
  }

  function back() {
    leerInputs();
    const min = estPdp ? 1 : 0;
    S.step = Math.max(min, S.step === 5 && !S.tercera ? 3 : S.step - 1); S.errs = {};
    render();
  }

  /* ---------- Vistas ---------- */
  const PASOS_CALC = ['Leyendo tu largo y la punta', 'Comparando tu metatarsal con el modelo', 'Ajustando por el empeine y el corte', 'Eligiendo tu talla'];
  const campo = (k, label, ph, aviso) => `
    <label class="nac-label">${label}
      <span class="nac-input${aviso ? ' nac-input--aviso' : ''}"><input type="text" inputmode="decimal" autocomplete="off" data-k="${k}" placeholder="${ph}" value="${esc(S[k])}"><span>cm</span></span>
    </label>`;
  const err = (t) => t ? `<div class="nac-err" role="alert">${esc(t)}</div>` : '';
  const b = (t) => `<b>${t}</b>`;

  function pintarCalc() {
    if (!ov || !S.calc) return;
    const ci = S.calcIdx;
    ov.querySelectorAll('.nac-calc__paso').forEach((el, i) => {
      const done = i < ci, act = i === ci;
      el.className = 'nac-calc__paso' + (done ? ' is-done' : act ? ' is-act' : '');
      el.querySelector('span').textContent = done ? '✓' : '';
    });
    const bar = ov.querySelector('.nac-calc__bar > div');
    if (bar) bar.style.width = Math.min(100, (ci + 1) * 22) + '%';
  }

  function media() {
    const s = S, M = CFG.media;
    const img = (src, alt) => `<img src="${src}" alt="${alt}" decoding="async">`;
    if (s.calc) return `<video src="${M.escaneo}" muted playsinline autoplay preload="auto"></video>`;
    if (s.step === 1) return img(M.largo, 'Talón contra la pared, marca con lápiz en la punta del pie');
    if (s.step === 2) return img(M.metatarsal, 'Cómo medir la vuelta del metatarsal');
    if (s.step === 3 || s.step === 4) return img(M.apoyada, 'Cinta apoyada sobre el pie, sin apretar');
    if (s.step === 5) return img(M.empeine, 'Cómo medir la vuelta del empeine');
    if (esPdpNombre(s.estilo) && CFG.imagen) return img(CFG.imagen, esc(CFG.titulo));
    return `<div class="nac-media__nombre">${esc(cap(s.estilo))}</div>`;
  }

  function cuerpo() {
    const s = S, r = s.res, nombre = cap(s.estilo);
    if (s.calc) {
      const m = s.med;
      return `<div class="nac-calc">
        <div class="nac-calc__eyebrow"><span></span>Analizando tu pie</div>
        <h3 class="nac-calc__h">Calculando tu talla…</h3>
        <div class="nac-calc__pasos">${PASOS_CALC.map((t, i) => `<div class="nac-calc__paso${i === 0 ? ' is-act' : ''}"><span></span>${t}</div>`).join('')}</div>
        <div class="nac-calc__bar"><div style="width:22%"></div></div>
        <div class="nac-calc__med">${m ? `Largo ${(m.largo_mm / 10).toFixed(1)} cm · Metatarsal ${(m.metatarsal_mm / 10).toFixed(1)} cm · Empeine ${(m.empeine_mm / 10).toFixed(1)} cm` : ''}</div>
      </div>`;
    }
    if (s.step === 0) {
      if (!S.lista) return `<div class="nac-paso"><h3>¿Qué modelo te interesa?</h3><p>Cargando modelos…</p></div>`;
      const ops = S.lista.map((e) => ({ v: e.nombre, l: cap(e.nombre) + ' · ' + cap(e.corte) })).sort((a, b) => a.l.localeCompare(b.l, 'es'));
      return `<div class="nac-paso">
        <h3>¿Qué modelo te interesa?</h3>
        <select class="nac-select" data-k="estilo"><option value="">Elige un modelo</option>${ops.map((o) => `<option value="${esc(o.v)}"${o.v === s.estilo ? ' selected' : ''}>${esc(o.l)}</option>`).join('')}</select>
        ${err(s.errs.modelo)}</div>`;
    }
    if (s.step === 1) return `<div class="nac-paso">
        <h3>El largo de tu pie.</h3>
        <p>Hoja en el piso, pegada a la pared. Párate con el ${b('talón tocando la pared')} y tu peso encima. Marca dónde termina tu ${b('dedo más largo')} y mide de la pared a la marca.</p>
        ${campo('largo', 'Largo · mide los dos pies y usa el más grande', '27.5')}
        <div class="nac-nota">Mide por la tarde y con el calcetín que usarías con este zapato.</div>
        ${err(s.errs.largo)}</div>`;
    if (s.step === 2) return `<div class="nac-paso">
        <h3>La vuelta de abajo.</h3>
        <p>Da la ${b('vuelta completa')} al pie pasando por el ${b('juanete')} y la ${b('base del dedo chiquito')}, de pie y con peso.</p>
        <div class="nac-tip"><b>La cinta apoyada, plana, sin apretar.</b> Solo que toque la piel en toda la vuelta — apretar es el error más común.</div>
        ${campo('m1', 'Vuelta de abajo', '26.0')}
        ${err(s.errs.meta)}</div>`;
    if (s.step === 3) return `<div class="nac-paso">
        <h3>Otra vez, para confirmar.</h3>
        <p>${b('Quita la cinta')} y vuelve a dar la vuelta de abajo, igual que antes: por el juanete y la base del dedo chiquito, apoyada y sin apretar.</p>
        ${campo('m2', 'Segunda medición', '')}
        <div class="nac-nota">Como en la imagen: la cinta lisa, sin arrugar la piel. Medir dos veces nos asegura que no estaba apretada.</div>
        ${err(s.errs.meta)}</div>`;
    if (s.step === 4) return `<div class="nac-paso">
        <h3>Una más, para desempatar.</h3>
        <p>Tus dos medidas salieron diferentes por más de 3 mm. Casi siempre es la tensión de la cinta. Mide una ${b('tercera vez')}, solo apoyada sobre la piel.</p>
        ${campo('m3', 'Tercera medición', '', true)}
        ${err(s.errs.meta)}</div>`;
    if (s.step === 5) return `<div class="nac-paso">
        <h3>La vuelta de arriba.</h3>
        <p>Vuelta completa por el ${b('hueso alto donde amarra la agujeta')}, cerrando por abajo del arco. Misma regla: apoyada, sin apretar. Siempre da ${b('más')} que la vuelta de abajo.</p>
        ${campo('emp', 'Empeine', '27.0')}
        ${err(s.errs.emp)}</div>`;
    return resultado(r || errorServidor(), nombre);
  }

  function resultado(r, nombre) {
    const s = S, m = s.medidas;
    const esPdp = esPdpNombre(s.estilo);
    const ajustado = r.notas && r.notas.some((n) => /ajustado/.test(n));
    const VER = { correcto: ajustado ? 'Te queda, ajustado los primeros días.' : 'Te quedará bien.', semi: 'Te quedará bien, un poco holgado del metatarsal.', plantilla: 'Te quedará bien con una plantilla extra.' };
    const NO = {
      apretado: ['Este modelo te quedaría apretado del metatarsal.', 'Cambiar de talla no lo arregla. Preferimos decírtelo antes de que compres.'],
      holgado: ['Para que te quede de largo, del metatarsal te quedaría suelto.', 'Cambiar de talla no lo arregla. Preferimos decírtelo antes de que compres.'],
      empeine: ['Tu empeine es alto para este corte sin agujeta.', 'Te costaría entrar y te apretaría arriba. Un modelo con agujeta te quedará mejor.']
    };
    const correo = (txtBtn, listo) => s.avisado ? `<div class="nac-ok">${listo}</div>` : `
      <form class="nac-correo" data-accion="avisar"><input type="email" required placeholder="tu@correo.com" data-k="correo" value="${esc(s.correo)}" autocomplete="email"><button class="nac-btn nac-btn--dark" type="submit">${txtBtn}</button></form>`;
    let h = '';
    if (r.ok) {
      const color = r.agotada ? '#b25000' : '#248a3d';
      h += `<div class="nac-res__top"><div class="nac-res__eyebrow">Tu talla en ${esc(nombre)}</div>
        <div class="nac-res__talla">${esc(r.talla)}</div>
        <div class="nac-res__equiv">MX ${esc(r.talla)} · USA ${esc(equiv(r.talla).usa)} · EURO ${esc(equiv(r.talla).eu)}</div>
        <div class="nac-res__ver" style="color:${color}"><span style="background:${color}"></span>${r.agotada ? `Tu talla en este modelo es ${esc(r.talla)}, temporalmente agotada.` : VER[r.calce] || ''}</div></div>`;
      if (r.agotada) h += correo('Avísame cuando llegue', 'Listo. Te escribimos en cuanto llegue tu talla.') + '<div id="nac-sug" class="nac-sug"></div>';
      else if (esPdp) h += `<div class="nac-acciones"><button class="nac-btn nac-btn--dark nac-btn--full" data-accion="elegir">Agregar talla ${esc(r.talla)} al carrito</button></div>`;
      else h += `<div class="nac-acciones"><a class="nac-btn nac-btn--dark nac-btn--full" href="${CFG.buscar}?q=${encodeURIComponent(cap(s.estilo))}">Ver ${esc(nombre)} en talla ${esc(r.talla)}</a></div>`;
      const notas = [...(r.avisos || []), ...(r.notas || [])];
      if (r.calce === 'plantilla') notas.push('Es nuestra talla más chica en este modelo. Con una plantilla extra queda a la medida de tu pie.');
      else if (!notas.some((n) => /ajustado/.test(n))) notas.push('La plantilla se amolda a tu pie en la primera semana.');
      h += `<div class="nac-notas">${notas.map((n) => `<div>${esc(n)}</div>`).join('')}</div>`;
    } else if (r.motivo === 'servidor') {
      h += `<div class="nac-res__no"><h3>No pudimos calcular tu talla.</h3><p>${esc(r.texto)}</p></div>`;
    } else {
      const no = NO[r.calce] || (r.motivo === 'rango' ? ['Este modelo no viene en tu talla.', 'Preferimos decírtelo antes de que compres. Déjanos tu correo y te avisamos cuando tengamos un modelo para tu pie.'] : ['Este modelo aún no tiene recomendador.', r.texto]);
      h += `<div class="nac-res__no"><div class="nac-res__eyebrow">${r.talla && r.calce !== 'holgado' ? `Por largo serías ${esc(r.talla)} en ${esc(nombre)}, pero…` : esc(nombre)}</div>
        <h3>${esc(no[0])}</h3><p>${esc(no[1])}</p></div>`;
      h += '<div id="nac-sug" class="nac-sug"></div>';
      h += correo('Avísame', 'Listo. Te escribimos cuando tengamos un modelo para tu pie.');
      h += `<button class="nac-btn nac-btn--light nac-self-start" data-accion="otro">Probar otro modelo</button>`;
    }
    const cuenta = CFG.logueado
      ? (valido(CFG.cliente) ? 'Tus medidas están guardadas en tu cuenta.' : 'Cuando compres, tus medidas quedan guardadas en tu cuenta.')
      : `Cuando compres, guardamos tus medidas en tu cuenta. <a href="${CFG.login}">Entra con tu correo</a> desde cualquier dispositivo y no tendrás que volver a medirte.`;
    h += `<div class="nac-pie"><div class="nac-pie__fila"><span>${m ? `Tus medidas: largo ${(m.L / 10).toFixed(1)} · metatarsal ${(m.M / 10).toFixed(1)} · empeine ${(m.E / 10).toFixed(1)} cm` : ''}</span><button class="nac-link" data-accion="medir">Volver a medir</button></div>
      ${r.ok && !r.agotada ? `<div>${cuenta}</div>` : ''}</div>`;
    return `<div class="nac-res">${h}</div>`;
  }

  function render() {
    if (!ov || !S.open) return;
    const s = S, on = s.step >= 1 && s.step <= 5 && !s.calc;
    const bar = (k) => `<div class="${k ? 'on' : ''}"></div>`;
    const nombre = cap(s.estilo);
    const minStep = estPdp ? 1 : 0;
    const paso = s.step <= 3 ? s.step : s.step === 4 ? 3 : 4;
    ov.innerHTML = `<div class="nac-wrap${s.step === 6 && !s.calc ? ' is-res' : ''}">
      <button class="nac-x" type="button" aria-label="Cerrar" data-accion="cerrar">&times;</button>
      <div class="nac-head">
        <div class="nac-eyebrow">Recomendador de talla</div>
        <h2>Encuentra tu talla exacta.</h2>
        <p>Una cinta métrica, una hoja de papel y tres minutos. Si un modelo no es para tu pie, te lo decimos antes de que compres.</p>
      </div>
      <div class="nac-card">
        <div class="nac-media">${media()}</div>
        <div class="nac-body">
          ${on ? `<div class="nac-prog"><div class="nac-prog__bars">${bar(s.step >= 1)}${bar(s.step >= 2)}${bar(s.step >= 3)}${bar(s.step >= 5)}</div>
            <div class="nac-prog__nombres">${['Largo', 'Metatarso', 'Confirmación', 'Empeine'].map((t, k) => `<span class="${paso === k + 1 ? 'on' : ''}">${t}</span>`).join('')}</div>
            <div class="nac-prog__txt"><span>Paso ${paso} de 4 · Midiendo: ${['Largo', 'Metatarso', 'Metatarso, otra vez', 'Empeine'][paso - 1]}</span><span>${esc(nombre)}</span></div></div>` : ''}
          ${cuerpo()}
          ${s.step <= 5 && !s.calc ? `<div class="nac-nav">${s.step > minStep ? '<button class="nac-link nac-link--back" data-accion="atras">Atrás</button>' : '<span></span>'}
            <button class="nac-btn nac-btn--blue" data-accion="next">${s.step === 5 ? 'Calcular mi talla' : 'Continuar'}</button></div>` : ''}
        </div>
      </div>
      <div class="nac-foot">Te medimos una vez: tus medidas quedan guardadas.</div>
    </div>`;
    if (ov.querySelector('#nac-sug')) pintarSugerencias(s.estilo);
    const v = ov.querySelector('video');
    if (v) { v.muted = true; v.addEventListener('ended', finCalc); const p = v.play(); if (p && p.catch) p.catch(() => {}); }
    const f = ov.querySelector('.nac-paso input');
    if (f && window.matchMedia('(hover:hover)').matches) f.focus({ preventScroll: true });
  }

  document.addEventListener('click', (e) => {
    const el = e.target.closest && e.target.closest('.nac-ov [data-accion]');
    if (!el || el.tagName === 'FORM') return;
    const a = el.dataset.accion;
    if (a === 'cerrar') return cerrar();
    if (a === 'next') return next();
    if (a === 'atras') return back();
    if (a === 'otro') { S.step = 0; S.res = null; S.errs = {}; S.estilo = ''; render(); cargarLista().then(render).catch(() => {}); return; }
    if (a === 'medir') { Object.assign(S, { step: estPdp ? 1 : 0, res: null, errs: {}, largo: '', m1: '', m2: '', m3: '', emp: '', tercera: false }); if (estPdp) S.estilo = estPdp.nombre; render(); if (!estPdp) cargarLista().then(render).catch(() => {}); return; }
    if (a === 'elegir') { emitir('agregar', { estilo: S.estilo, talla: S.res.talla }); const t = S.res.talla; cerrar(); agregarCarrito(t); }
  });
  document.addEventListener('keydown', (e) => {
    if (e.key === 'Enter' && e.target.closest && e.target.closest('.nac-paso') && e.target.matches('input')) { e.preventDefault(); next(); }
  });
  document.addEventListener('change', (e) => { if (e.target.matches && e.target.matches('.nac-ov select[data-k]')) S[e.target.dataset.k] = e.target.value; });
  document.addEventListener('submit', (e) => {
    const f = e.target.closest && e.target.closest('.nac-ov form[data-accion="avisar"]');
    if (!f) return;
    e.preventDefault(); leerInputs();
    if (!/.+@.+\..+/.test(S.correo)) return;
    const r = S.res || {}, tag = (x) => norm(String(x)).toLowerCase().replace(/[^a-z0-9.]+/g, '-');
    const fd = new FormData();
    fd.append('form_type', 'customer'); fd.append('utf8', '✓');
    fd.append('contact[email]', S.correo);
    fd.append('contact[tags]', ['aviso-talla', 'aviso-' + tag(S.estilo) + (r.talla ? '-' + tag(r.talla) : ''), r.agotada ? 'aviso-agotada' : 'aviso-sin-modelo'].join(','));
    fetch(raiz() + 'contact', { method: 'POST', body: fd }).catch(() => {});
    emitir('aviso', { correo: S.correo, ...S.med });
    S.avisado = true; render();
  });

  /* ---------- Arranque ---------- */
  const compras = [...new Set((CFG.compras || []).filter(Boolean).map((c) => c.e || c.t))];
  api({ accion: 'ficha', estilo: CFG.estilo, titulo: CFG.titulo, m: valido(S.medidas) ? medidasApi(S.medidas) : null, compras })
    .then((d) => {
      if (!d || !d.est) return; // sin horma (hoy PENNY) o modelo fuera del catálogo: no se muestra nada
      estPdp = d.est; S.resPdp = d.res; S.extra = d.extra || {};
      // El recomendador manda: se oculta el aviso de horma del tema («Pide media talla menos») para no dar dos tallas.
      document.documentElement.classList.add('nac-activo');
      if (valido(S.medidas)) sincronizarCarrito(S.medidas);
      pintarFicha();
      // El tema vuelve a dibujar el selector al cambiar de color: repintar tarjeta y talla.
      let t;
      const obs = new MutationObserver(() => { clearTimeout(t); t = setTimeout(pintarFicha, 60); });
      const p = picker();
      if (p) obs.observe(p.parentNode, { childList: true, subtree: true });
      const fid = formId();
      document.addEventListener('change', (e) => { if (e.target.getAttribute && e.target.getAttribute('form') === fid) { clearTimeout(t); t = setTimeout(pintarFicha, 60); } });
    })
    .catch(() => {});
})();
